import { decamelizeKeys } from "humps";
import api from "PFCore/api";
import { Id } from "PFTypes";
import { ChangeRequest } from "PFTypes/change_request";

export const fetchChangeRequest = (id: Id) =>
  api<ChangeRequest>({
    url: `change_requests/${id}`
  }).then((resp) => decamelizeKeys(resp) as ChangeRequest); // TODO: [PROF-5746] Remove decamelizeKeys when app is camelized
